export default {"src":"/_next/static/media/m4.b636c41f.svg","height":37,"width":138};